var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',[_c('v-row',[_c('v-col',[_vm._v(" Logics "),_c('json-viewer',{attrs:{"value":_vm.logics}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }